import Vue from 'vue'
import Vuex from 'vuex'

import cases from './cases'
import plans from './plans'
import products from './products'
import users from './users'
import services from './services'
import roles from './roles'
import clients from './clients'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogged: Boolean(localStorage.getItem('oauthToken')) || false,
    mainMenuDrawer: true,
    editItemId: 0,
    editItemIdPermissions: 0,
    dfsConfig: {},
    axios: {},
    createCaseOfflineRequestsPool: [],
    loggedUserEmail: localStorage.getItem('loggedUserEmail') || '',
    currentUser: JSON.parse(localStorage.getItem('currentUser')) || {},
    currentUserRoles: JSON.parse(localStorage.getItem('currentUserRoles')) || [],
    appIsLoaded: false
  },
  mutations: {
    logIn (state) {
      state.isLogged = true
    },
    logOut (state) {
      state.loggedUserEmail = ''
      state.currentUser = {}
      state.currentUserRoles = []
      state.isLogged = false
    },
    toggleMainMenuDrawer (state) {
      state.mainMenuDrawer = !state.mainMenuDrawer
    },
    setAxios (state, axios) {
      state.axios = axios
    },
    setConfig (state, config) {
      state.dfsConfig = config
    },
    setEditItemId (state, itemId) {
      state.editItemId = itemId
    },
    setEditItemIdPermissions (state, itemId) {
      state.editItemIdPermissions = itemId
    },
    setLoggedUserEmail (state, email) {
      state.loggedUserEmail = email
    },
    setCurrentUser (state, user) {
      state.currentUser = user
    },
    setCurrentUserRoles (state, roles) {
      state.currentUserRoles = roles
    },
    setAppIsLoaded (state, status) {
      state.appIsLoaded = status
    }
  },
  actions: {
    logIn (context) {
      context.commit('logIn')
    },
    logOut (context) {
      context.commit('logOut')
    },
    toggleMainMenuDrawer ({ commit }) {
      commit('toggleMainMenuDrawer')
    },
    setAxios (context, axios) {
      context.commit('setAxios', axios)
    },
    setConfig (context, config) {
      context.commit('setConfig', config)
    },
    setEditItemId (context, itemId) {
      context.commit('setEditItemId', itemId)
    },
    setEditItemIdPermissions (context, itemId) {
      context.commit('setEditItemIdPermissions', itemId)
    },
    setLoggedUserEmail (context, email) {
      context.commit('setLoggedUserEmail', email)
    },
    setCurrentUser (context, user) {
      context.commit('setCurrentUser', user)
    },
    setCurrentUserRoles (context, roles) {
      context.commit('setCurrentUserRoles', roles)
    },
    setAppIsLoaded (context, status) {
      context.commit('setAppIsLoaded', status)
    }
  },
  getters: {
    logInStatus: state => {
      return state.isLogged
    },
    axios: state => {
      return state.axios
    },
    config: state => {
      return state.dfsConfig
    },
    editItemId: state => {
      return state.editItemId
    },
    editItemIdPermissions: state => {
      return state.editItemIdPermissions
    },
    loggedUserEmail: state => {
      return state.loggedUserEmail
    },
    currentUser: state => {
      return state.currentUser
    },
    currentUserRoles: state => {
      return state.currentUserRoles
    },
    appIsLoaded: state => {
      return state.appIsLoaded
    }
  },
  modules: {
    cases,
    plans,
    products,
    users,
    services,
    roles,
    clients
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js